// extracted by mini-css-extract-plugin
module.exports = {"disabled":"style-module_disabled__Lhc5vUKFRpO1yXAVsRKI"};